import { useContext, useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { Loader, SearchBar } from "../../../components";
import { Colors } from "../../../constants/styles";
import { Container, Card, Form, Row, Col, InputGroup } from "react-bootstrap";
import {
  Box,
  Paper,
  Alert,
  Button,
  Snackbar,
  Autocomplete,
  TextField,
  Dialog,
  DialogTitle,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Pagination,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import { makeStyles } from "@mui/styles";
import { NumericFormat } from "react-number-format";
import { ReactSketchCanvas } from "react-sketch-canvas";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import useScreenWidth from "../../../hooks/useScreenWidth";

const useStyles = makeStyles({
  root: {
    "& .MuiTableCell-head": {
      color: "white",
      backgroundColor: Colors.blue700,
    },
  },
  tableRightBorder: {
    borderWidth: 0,
    borderRightWidth: 1,
    borderColor: "white",
    borderStyle: "solid",
  },
});

const TambahSurveyFidusia = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [alamatSama, setAlamatSama] = useState(false);
  const [registerFidusiaId, setRegisterFidusiaId] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [cif, setCif] = useState("");
  const [nikCustomer, setNikCustomer] = useState("");
  const [noKkCustomer, setNoKkCustomer] = useState("");
  const [namaCustomer, setNamaCustomer] = useState("");
  const [namaPanggilanCustomer, setNamaPanggilanCustomer] = useState("");
  const [tempatLahirCustomer, setTempatLahirCustomer] = useState("");
  const [tanggalLahirCustomer, setTanggalLahirCustomer] = useState(new Date());
  const [jenisKelaminCustomer, setJenisKelaminCustomer] = useState("");
  const [agamaCustomer, setAgamaCustomer] = useState("");
  const [noTeleponCustomer, setNoTeleponCustomer] = useState("");
  const [alamatCustomer, setAlamatCustomer] = useState("");
  const [alamatTTCustomer, setAlamatTTCustomer] = useState("");
  const [kodeProvinsi, setKodeProvinsi] = useState("");
  const [ketProvinsi, setKetProvinsi] = useState("");
  const [kodeProvinsiTT, setKodeProvinsiTT] = useState("");
  const [ketProvinsiTT, setKetProvinsiTT] = useState("");
  const [kodeKabupaten, setKodeKabupaten] = useState("");
  const [ketKabupaten, setKetKabupaten] = useState("");
  const [kodeKabupatenTT, setKodeKabupatenTT] = useState("");
  const [ketKabupatenTT, setKetKabupatenTT] = useState("");
  const [kodeKecamatan, setKodeKecamatan] = useState("");
  const [ketKecamatan, setKetKecamatan] = useState("");
  const [kodeKecamatanTT, setKodeKecamatanTT] = useState("");
  const [ketKecamatanTT, setKetKecamatanTT] = useState("");
  const [kodeKelurahan, setKodeKelurahan] = useState("");
  const [ketKelurahan, setKetKelurahan] = useState("");
  const [kodeKelurahanTT, setKodeKelurahanTT] = useState("");
  const [ketKelurahanTT, setKetKelurahanTT] = useState("");
  const [kodePos, setKodePos] = useState("");
  const [kodePosTT, setKodePosTT] = useState("");
  const [statusPerkawinanCustomer, setStatusPerkawinanCustomer] = useState("");
  const [pekerjaanCustomer, setPekerjaanCustomer] = useState("");
  const [kewarganegaraanCustomer, setKewarganegaraanCustomer] = useState("");

  const [namaPerusahaanCustomer, setNamaPerusahaanCustomer] = useState("");
  const [bidangUsahaCustomer, setBidangUsahaCustomer] = useState("");
  const [jabatanCustomer, setJabatanCustomer] = useState("");
  const [alamatPerusahaanCustomer, setAlamatPerusahaanCustomer] = useState("");
  const [noTeleponPerusahaanCustomer, setNoTeleponPerusahaanCustomer] =
    useState("");
  const [lamaKerjaCustomer, setLamaKerjaCustomer] = useState("");
  const [gajiPekerjaanCustomer, setGajiPekerjaanCustomer] = useState("0");
  const [pendapatanLainCustomer, setPendapatanLainCustomer] = useState("0");

  // Data Penjamin
  const [nikPenjamin, setNikPenjamin] = useState("");
  const [noKkPenjamin, setNoKkPenjamin] = useState("");
  const [namaPenjamin, setNamaPenjamin] = useState("");
  const [tempatLahirPenjamin, setTempatLahirPenjamin] = useState("");
  const [tanggalLahirPenjamin, setTanggalLahirPenjamin] = useState(null);
  const [jenisKelaminPenjamin, setJenisKelaminPenjamin] = useState("");
  const [agamaPenjamin, setAgamaPenjamin] = useState("");
  const [noTeleponPenjamin, setNoTeleponPenjamin] = useState("");
  const [alamatPenjamin, setAlamatPenjamin] = useState("");
  const [kodeProvinsiPenjamin, setKodeProvinsiPenjamin] = useState("");
  const [ketProvinsiPenjamin, setKetProvinsiPenjamin] = useState("");
  const [kodeKabupatenPenjamin, setKodeKabupatenPenjamin] = useState("");
  const [ketKabupatenPenjamin, setKetKabupatenPenjamin] = useState("");
  const [kodeKecamatanPenjamin, setKodeKecamatanPenjamin] = useState("");
  const [ketKecamatanPenjamin, setKetKecamatanPenjamin] = useState("");
  const [kodeKelurahanPenjamin, setKodeKelurahanPenjamin] = useState("");
  const [ketKelurahanPenjamin, setKetKelurahanPenjamin] = useState("");
  const [kodePosPenjamin, setKodePosPenjamin] = useState("");
  const [statusPerkawinanPenjamin, setStatusPerkawinanPenjamin] = useState("");
  const [namaPerusahaanPenjamin, setNamaPerusahaanPenjamin] = useState("");
  const [alamatPerusahaanPenjamin, setAlamatPerusahaanPenjamin] = useState("");
  const [pekerjaanPenjamin, setPekerjaanPenjamin] = useState("");
  const [lamaKerjaPenjamin, setLamaKerjaPenjamin] = useState("");
  const [kewarganegaraanPenjamin, setKewarganegaraanPenjamin] = useState("");
  const [hubunganPenjamin, setHubunganPenjamin] = useState("");

  const [alamatSamaPenjamin, setAlamatSamaPenjamin] = useState(false);
  const [alamatTTPenjamin, setAlamatTTPenjamin] = useState("");
  const [kodeProvinsiTTPenjamin, setKodeProvinsiTTPenjamin] = useState("");
  const [ketProvinsiTTPenjamin, setKetProvinsiTTPenjamin] = useState("");
  const [kodeKabupatenTTPenjamin, setKodeKabupatenTTPenjamin] = useState("");
  const [ketKabupatenTTPenjamin, setKetKabupatenTTPenjamin] = useState("");
  const [kodeKecamatanTTPenjamin, setKodeKecamatanTTPenjamin] = useState("");
  const [ketKecamatanTTPenjamin, setKetKecamatanTTPenjamin] = useState("");
  const [kodeKelurahanTTPenjamin, setKodeKelurahanTTPenjamin] = useState("");
  const [ketKelurahanTTPenjamin, setKetKelurahanTTPenjamin] = useState("");
  const [kodePosTTPenjamin, setKodePosTTPenjamin] = useState("");

  const [uangMuka, setUangMuka] = useState("");
  const [pinjamanAju, setPinjamanAju] = useState("");
  const [angPerBulan, setAngPerBulan] = useState("");
  const [tenor, setTenor] = useState("");

  // DATA KENDARAAN
  const [merk, setMerk] = useState("");
  const [tipe, setTipe] = useState("");
  const [tahun, setTahun] = useState("");
  const [warna, setWarna] = useState("");
  const [isi, setIsi] = useState("");
  const [nopol, setNopol] = useState("");
  const [noRangka, setNoRangka] = useState("");
  const [noMesin, setNoMesin] = useState("");
  const [tglStnk, setTglStnk] = useState(null);
  const [noBpkb, setNoBpkb] = useState("");
  const [bpkbAN, setBpkbAN] = useState("");
  const [bpkbAlamat, setBpkbAlamat] = useState("");

  const [linkMapsSurvey, setLinkMapsSurvey] = useState("");

  // DATA REFERENSI
  const [namaRefRegister, setNamaRefRegister] = useState("");
  const [alamatRefRegister, setAlamatRefRegister] = useState("");
  const [teleponRefRegister, setTeleponRefRegister] = useState("");
  const [hubunganRefRegister, setHubunganRefRegister] = useState("");
  // const [statusPerkawinanRefRegister, setStatusPerkawinanRefRegister] =
  //   useState("");
  const [namaRef2Register, setNamaRef2Register] = useState("");
  const [alamatRef2Register, setAlamatRef2Register] = useState("");
  const [teleponRef2Register, setTeleponRef2Register] = useState("");
  const [hubunganRef2Register, setHubunganRef2Register] = useState("");
  // const [statusPerkawinanRef2Register, setStatusPerkawinanRef2Register] =
  //   useState("");
  const [namaRef3Register, setNamaRef3Register] = useState("");
  const [alamatRef3Register, setAlamatRef3Register] = useState("");
  const [teleponRef3Register, setTeleponRef3Register] = useState("");
  const [hubunganRef3Register, setHubunganRef3Register] = useState("");
  // const [statusPerkawinanRef3Register, setStatusPerkawinanRef3Register] =
  //   useState("");

  // DATA PINJAMAN
  const [hargaOtr, setHargaOtr] = useState("");
  const [tglJtTempo, setTglJtTempo] = useState(null);
  const [tujuanPenggunaanDana, setTujuanPenggunaanDana] = useState("");
  const [pendinganPengurusan, setPendinganPengurusan] = useState("");
  const [kodeMarketing, setKodeMarketing] = useState("");
  const [kodeSurveyor, setKodeSurveyor] = useState("");

  const [keteranganSurvey, setKeteranganSurvey] = useState(
    "Saya menyatakan benar dan akurat atas seluruh informasi dan atau dokumen yang saya berikan kepada PT Sistem Gadai. Apabila ternyata dikemudian hari informasi tersebut tidak benar, saya bersedia mempertanggungjawabkannya, dan sanggup menaati segala peraturan perjanjian yang telah ditetapkan oleh perusahaan. Tujuan setiap setoran dana bukanlah berasal dari Tindak Pidana Pencucian Uang dan tujuan Pinjaman dana bukan bertujuan untuk kaitanya Tindak Pidana Pencucian Uang, Tindak Pidana Pendanaan Terorisme maupun Pendanaan Proliferasi Senjata Pemusnah Masal. Apabila di kemudian hari terbukti melakukan tujuan tujuan tersebut maka saya bersedia tunduk pada peraturan perundang-undangan yang berlaku."
  );
  const [keterangan, setKeterangan] = useState("");

  const [namaTtdSurvey, setNamaTtdSurvey] = useState("");

  const canvasRef = useRef(null);
  const [eraseMode, setEraseMode] = useState(false);

  const canvasRefDenahLokasiSurvey = useRef(null);
  const [eraseModeDenahLokasiSurvey, setEraseModeDenahLokasiSurvey] =
    useState(false);

  const [kelurahans, setKelurahans] = useState([]);
  const [kecamatans, setKecamatans] = useState([]);
  const [kabupatens, setKabupatens] = useState([]);
  const [provinsis, setProvinsis] = useState([]);
  const [marketings, setMarketings] = useState([]);
  const [surveyors, setSurveyors] = useState([]);
  const [registers, setRegisters] = useState([]);
  const [tipes, setTipes] = useState([]);
  const [warnas, setWarnas] = useState([]);
  const [searchTermRegister, setSearchTermRegister] = useState("");
  const [openRegister, setOpenRegister] = useState(false);
  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const classes = useStyles();

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTermRegister(query);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleClickOpenRegister = () => {
    setOpenRegister(true);
  };

  const handleCloseRegister = () => {
    setOpenRegister(false);
  };

  const handleEraserClick = () => {
    setEraseMode(true);
    canvasRef.current?.eraseMode(true);
  };

  const handlePenClick = () => {
    setEraseMode(false);
    canvasRef.current?.eraseMode(false);
  };

  const handleUndoClick = () => {
    canvasRef.current?.undo();
  };

  const handleRedoClick = () => {
    canvasRef.current?.redo();
  };

  const handleClearClick = () => {
    canvasRef.current?.clearCanvas();
  };

  const handleResetClick = () => {
    canvasRef.current?.resetCanvas();
  };

  const handleEraserClickDenahLokasiSurvey = () => {
    setEraseModeDenahLokasiSurvey(true);
    canvasRefDenahLokasiSurvey.current?.eraseMode(true);
  };

  const handlePenClickDenahLokasiSurvey = () => {
    setEraseModeDenahLokasiSurvey(false);
    canvasRefDenahLokasiSurvey.current?.eraseMode(false);
  };

  const handleUndoClickDenahLokasiSurvey = () => {
    canvasRefDenahLokasiSurvey.current?.undo();
  };

  const handleRedoClickDenahLokasiSurvey = () => {
    canvasRefDenahLokasiSurvey.current?.redo();
  };

  const handleClearClickDenahLokasiSurvey = () => {
    canvasRefDenahLokasiSurvey.current?.clearCanvas();
  };

  const handleResetClickDenahLokasiSurvey = () => {
    canvasRefDenahLokasiSurvey.current?.resetCanvas();
  };

  const jenisKelaminOption = ["LAKI-LAKI", "PEREMPUAN"];
  const agamaOption = [
    "ISLAM",
    "PROTESTAN",
    "KATOLIK",
    "HINDU",
    "BUDHA",
    "KHONGHUCU",
    "LAIN",
  ];
  const statusPerkawinanOption = [
    "BELUM MENIKAH",
    "(JANDA/DUDA)",
    "MENIKAH",
    "MENIKAH / ISTRI",
    "MENIKAH / SUAMI",
  ];
  const kewarganegaraanOption = ["WNI", "WNA"];
  let kelurahanOptions = kelurahans.map((kelurahan) => ({
    label: `${kelurahan.id} - ${kelurahan.namaKelurahan}`,
  }));
  let kecamatanOptions = kecamatans.map((kecamatan) => ({
    label: `${kecamatan.id} - ${kecamatan.namaKecamatan}`,
  }));
  let kabupatenOptions = kabupatens.map((kabupaten) => ({
    label: `${kabupaten.id} - ${kabupaten.namaKabupaten}`,
  }));
  let provinsiOptions = provinsis.map((provinsi) => ({
    label: `${provinsi.id} - ${provinsi.namaProvinsi}`,
  }));
  let marketingOptions = marketings.map((marketing) => ({
    label: `${marketing.kodeMarketing} - ${marketing.namaMarketing}`,
  }));
  let surveyorOptions = surveyors.map((surveyor) => ({
    label: `${surveyor.kodeSurveyor} - ${surveyor.namaSurveyor}`,
  }));
  let tipeOptions = tipes.map((tipe) => ({
    label: `${tipe.kodeTipe} | ${tipe.namaTipe}`,
  }));

  useEffect(() => {
    getAreaData();
    getMarketingsData();
    getSurveyorsData();
    getTipesData();
    getWarnasData();
  }, []);

  useEffect(() => {
    getRegistersData();
  }, [page, searchTermRegister]);

  const getMarketingsData = async () => {
    const response = await axios.post(`${tempUrl}/marketings`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setMarketings(response.data);
  };

  const getSurveyorsData = async () => {
    const response = await axios.post(`${tempUrl}/surveyors`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setSurveyors(response.data);
  };

  const getTipesData = async () => {
    const response = await axios.post(`${tempUrl}/tipes`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setTipes(response.data);
  };

  const getWarnasData = async (kodeUnit) => {
    const response = await axios.post(`${tempUrl}/warnas`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setWarnas(response.data);
  };

  const getRegistersData = async () => {
    const response = await axios.post(
      `${tempUrl}/registerFidusiasPerCabangBlmSurveyPagination?search_query=${searchTermRegister}&page=${page}&limit=${limit}`,
      {
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      }
    );
    setRegisters(response.data.registerFidusias);
    setPage(response.data.page);
    setPages(response.data.totalPage);
    setRows(response.data.totalRows);
  };

  const getAreaData = async (kodeUnit) => {
    const allKelurahan = await axios.post(`${tempUrl}/kelurahans`, {
      _id: user.id,
      token: user.token,
    });
    setKelurahans(allKelurahan.data);

    const allKecamatan = await axios.post(`${tempUrl}/kecamatans`, {
      _id: user.id,
      token: user.token,
    });
    setKecamatans(allKecamatan.data);

    const allKabupaten = await axios.post(`${tempUrl}/kabupatens`, {
      _id: user.id,
      token: user.token,
    });
    setKabupatens(allKabupaten.data);

    const allProvinsi = await axios.post(`${tempUrl}/provinsis`, {
      _id: user.id,
      token: user.token,
    });
    setProvinsis(allProvinsi.data);

    setJenisKelaminCustomer(jenisKelaminOption[0]);
    setAgamaCustomer(agamaOption[0]);
    setStatusPerkawinanCustomer(statusPerkawinanOption[0]);
    setKewarganegaraanCustomer(kewarganegaraanOption[0]);

    setJenisKelaminPenjamin(jenisKelaminOption[0]);
    setAgamaPenjamin(agamaOption[0]);
    setStatusPerkawinanPenjamin(statusPerkawinanOption[0]);
    setKewarganegaraanPenjamin(kewarganegaraanOption[0]);

    // setStatusPerkawinanRefRegister(statusPerkawinanOption[0]);
    // setStatusPerkawinanRef2Register(statusPerkawinanOption[0]);
    // setStatusPerkawinanRef3Register(statusPerkawinanOption[0]);
  };

  const findKelurahan = async (kelurahanId) => {
    if (kelurahanId) {
      const response = await axios.post(
        `${tempUrl}/kelurahans/${kelurahanId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKelurahan(kelurahanId);
      if (kelurahanId == "99999999") {
        setKodeProvinsi("");
        setKodeKabupaten("");
        setKodeKecamatan("");
        setKodePos("");
        setKodeKelurahan(kelurahanId);
        return;
      }
      if (response.data) {
        setKodeProvinsi(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupaten(
          `${response.data.kabupaten.id} - ${response.data.kabupaten.namaKabupaten}`
        );
        setKodeKecamatan(
          `${response.data.kecamatan.id} - ${response.data.kecamatan.namaKecamatan}`
        );
        setKodePos(response.data.kodePos);
        setKodeKelurahan(kelurahanId);
      }
    }
  };

  const findKelurahanPenjamin = async (kelurahanId) => {
    if (kelurahanId) {
      const response = await axios.post(
        `${tempUrl}/kelurahans/${kelurahanId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKelurahanPenjamin(kelurahanId);
      if (kelurahanId == "99999999") {
        setKodeProvinsiPenjamin("");
        setKodeKabupatenPenjamin("");
        setKodeKecamatanPenjamin("");
        setKodePosPenjamin("");
        setKodeKelurahanPenjamin(kelurahanId);
        return;
      }
      if (response.data) {
        setKodeProvinsiPenjamin(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupatenPenjamin(
          `${response.data.kabupaten.id} - ${response.data.kabupaten.namaKabupaten}`
        );
        setKodeKecamatanPenjamin(
          `${response.data.kecamatan.id} - ${response.data.kecamatan.namaKecamatan}`
        );
        setKodePosPenjamin(response.data.kodePos);
        setKodeKelurahanPenjamin(kelurahanId);
      }
    }
  };

  const findKelurahanTT = async (kelurahanId) => {
    if (kelurahanId) {
      const response = await axios.post(
        `${tempUrl}/kelurahans/${kelurahanId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKelurahanTT(kelurahanId);
      if (kelurahanId == "99999999") {
        setKodeProvinsiTT("");
        setKodeKabupatenTT("");
        setKodeKecamatanTT("");
        if (alamatSama && kodePos.length > 0) {
          setKodePosTT(kodePos);
        } else {
          setKodePosTT("");
        }
        setKodeKelurahanTT(kelurahanId);
        return;
      }
      if (response.data) {
        setKodeProvinsiTT(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupatenTT(
          `${response.data.kabupaten.id} - ${response.data.kabupaten.namaKabupaten}`
        );
        setKodeKecamatanTT(
          `${response.data.kecamatan.id} - ${response.data.kecamatan.namaKecamatan}`
        );
        setKodePosTT(response.data.kodePos);
        setKodeKelurahanTT(kelurahanId);
      }
    }
  };

  const findKelurahanTTPenjamin = async (kelurahanId) => {
    if (kelurahanId) {
      const response = await axios.post(
        `${tempUrl}/kelurahans/${kelurahanId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKelurahanTTPenjamin(kelurahanId);
      if (kelurahanId == "99999999") {
        setKodeProvinsiTTPenjamin("");
        setKodeKabupatenTTPenjamin("");
        setKodeKecamatanTTPenjamin("");
        if (alamatSama && kodePos.length > 0) {
          setKodePosTTPenjamin(kodePos);
        } else {
          setKodePosTTPenjamin("");
        }
        setKodeKelurahanTTPenjamin(kelurahanId);
        return;
      }
      if (response.data) {
        setKodeProvinsiTTPenjamin(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupatenTTPenjamin(
          `${response.data.kabupaten.id} - ${response.data.kabupaten.namaKabupaten}`
        );
        setKodeKecamatanTTPenjamin(
          `${response.data.kecamatan.id} - ${response.data.kecamatan.namaKecamatan}`
        );
        setKodePosTTPenjamin(response.data.kodePos);
        setKodeKelurahanTTPenjamin(kelurahanId);
      }
    }
  };

  const findKecamatan = async (kecamatanId) => {
    kecamatanId = kecamatanId.split(" ", 1)[0];
    if (kecamatanId) {
      const response = await axios.post(
        `${tempUrl}/kecamatans/${kecamatanId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKecamatan(kecamatanId);
      if (kecamatanId == "999999") {
        setKodeProvinsi("");
        setKodeKabupaten("");
        setKodeKecamatan(
          `${response.data.id} - ${response.data.namaKecamatan}`
        );
        return;
      }
      if (response.data) {
        setKodeProvinsi(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupaten(
          `${response.data.kabupaten.id} - ${response.data.kabupaten.namaKabupaten}`
        );
        setKodeKecamatan(
          `${response.data.id} - ${response.data.namaKecamatan}`
        );
      }
    }
  };

  const findKecamatanPenjamin = async (kecamatanId) => {
    kecamatanId = kecamatanId.split(" ", 1)[0];
    if (kecamatanId) {
      const response = await axios.post(
        `${tempUrl}/kecamatans/${kecamatanId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKecamatan(kecamatanId);
      if (kecamatanId == "999999") {
        setKodeProvinsiPenjamin("");
        setKodeKabupatenPenjamin("");
        setKodeKecamatanPenjamin(
          `${response.data.id} - ${response.data.namaKecamatan}`
        );
        return;
      }
      if (response.data) {
        setKodeProvinsiPenjamin(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupatenPenjamin(
          `${response.data.kabupaten.id} - ${response.data.kabupaten.namaKabupaten}`
        );
        setKodeKecamatanPenjamin(
          `${response.data.id} - ${response.data.namaKecamatan}`
        );
      }
    }
  };

  const findKecamatanTT = async (kecamatanId) => {
    kecamatanId = kecamatanId.split(" ", 1)[0];
    if (kecamatanId) {
      const response = await axios.post(
        `${tempUrl}/kecamatans/${kecamatanId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKecamatanTT(kecamatanId);
      if (kecamatanId == "999999") {
        setKodeProvinsiTT("");
        setKodeKabupatenTT("");
        setKodeKecamatanTT(
          `${response.data.id} - ${response.data.namaKecamatan}`
        );
        return;
      }
      if (response.data) {
        setKodeProvinsiTT(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupatenTT(
          `${response.data.kabupaten.id} - ${response.data.kabupaten.namaKabupaten}`
        );
        setKodeKecamatanTT(
          `${response.data.id} - ${response.data.namaKecamatan}`
        );
      }
    }
  };

  const findKecamatanTTPenjamin = async (kecamatanId) => {
    kecamatanId = kecamatanId.split(" ", 1)[0];
    if (kecamatanId) {
      const response = await axios.post(
        `${tempUrl}/kecamatans/${kecamatanId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKecamatanTTPenjamin(kecamatanId);
      if (kecamatanId == "999999") {
        setKodeProvinsiTTPenjamin("");
        setKodeKabupatenTTPenjamin("");
        setKodeKecamatanTTPenjamin(
          `${response.data.id} - ${response.data.namaKecamatan}`
        );
        return;
      }
      if (response.data) {
        setKodeProvinsiTTPenjamin(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupatenTTPenjamin(
          `${response.data.kabupaten.id} - ${response.data.kabupaten.namaKabupaten}`
        );
        setKodeKecamatanTTPenjamin(
          `${response.data.id} - ${response.data.namaKecamatan}`
        );
      }
    }
  };

  const findKabupaten = async (kabupatenId) => {
    kabupatenId = kabupatenId.split(" ", 1)[0];
    if (kabupatenId) {
      const response = await axios.post(
        `${tempUrl}/kabupatens/${kabupatenId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKabupaten(kabupatenId);
      if (kabupatenId == "9999") {
        setKodeProvinsi("");
        setKodeKabupaten(
          `${response.data.id} - ${response.data.namaKabupaten}`
        );
        return;
      }
      if (response.data) {
        setKodeProvinsi(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupaten(
          `${response.data.id} - ${response.data.namaKabupaten}`
        );
      }
    }
  };

  const findKabupatenPenjamin = async (kabupatenId) => {
    kabupatenId = kabupatenId.split(" ", 1)[0];
    if (kabupatenId) {
      const response = await axios.post(
        `${tempUrl}/kabupatens/${kabupatenId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKabupatenPenjamin(kabupatenId);
      if (kabupatenId == "9999") {
        setKodeProvinsiPenjamin("");
        setKodeKabupatenPenjamin(
          `${response.data.id} - ${response.data.namaKabupaten}`
        );
        return;
      }
      if (response.data) {
        setKodeProvinsiPenjamin(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupatenPenjamin(
          `${response.data.id} - ${response.data.namaKabupaten}`
        );
      }
    }
  };

  const findKabupatenTT = async (kabupatenId) => {
    kabupatenId = kabupatenId.split(" ", 1)[0];
    if (kabupatenId) {
      const response = await axios.post(
        `${tempUrl}/kabupatens/${kabupatenId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKabupatenTT(kabupatenId);
      if (kabupatenId == "9999") {
        setKodeProvinsiTT("");
        setKodeKabupatenTT(
          `${response.data.id} - ${response.data.namaKabupaten}`
        );
        return;
      }
      if (response.data) {
        setKodeProvinsiTT(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupatenTT(
          `${response.data.id} - ${response.data.namaKabupaten}`
        );
      }
    }
  };

  const findKabupatenTTPenjamin = async (kabupatenId) => {
    kabupatenId = kabupatenId.split(" ", 1)[0];
    if (kabupatenId) {
      const response = await axios.post(
        `${tempUrl}/kabupatens/${kabupatenId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKabupatenTTPenjamin(kabupatenId);
      if (kabupatenId == "9999") {
        setKodeProvinsiTTPenjamin("");
        setKodeKabupatenTTPenjamin(
          `${response.data.id} - ${response.data.namaKabupaten}`
        );
        return;
      }
      if (response.data) {
        setKodeProvinsiTTPenjamin(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupatenTTPenjamin(
          `${response.data.id} - ${response.data.namaKabupaten}`
        );
      }
    }
  };

  const findProvinsi = async (provinsiId) => {
    provinsiId = provinsiId.split(" ", 1)[0];
    if (provinsiId) {
      const response = await axios.post(`${tempUrl}/provinsis/${provinsiId}`, {
        _id: user.id,
        token: user.token,
      });
      // setKodeProvinsi(provinsiId);
      if (response.data) {
        setKodeProvinsi(`${response.data.id} - ${response.data.namaProvinsi}`);
      }
    }
  };

  const findProvinsiPenjamin = async (provinsiId) => {
    provinsiId = provinsiId.split(" ", 1)[0];
    if (provinsiId) {
      const response = await axios.post(`${tempUrl}/provinsis/${provinsiId}`, {
        _id: user.id,
        token: user.token,
      });
      // setKodeProvinsiPenjamin(provinsiId);
      if (response.data) {
        setKodeProvinsiPenjamin(
          `${response.data.id} - ${response.data.namaProvinsi}`
        );
      }
    }
  };

  const findProvinsiTT = async (provinsiId) => {
    provinsiId = provinsiId.split(" ", 1)[0];
    if (provinsiId) {
      const response = await axios.post(`${tempUrl}/provinsis/${provinsiId}`, {
        _id: user.id,
        token: user.token,
      });
      // setKodeProvinsiTT(provinsiId);
      if (response.data) {
        setKodeProvinsiTT(
          `${response.data.id} - ${response.data.namaProvinsi}`
        );
      }
    }
  };

  const findProvinsiTTPenjamin = async (provinsiId) => {
    provinsiId = provinsiId.split(" ", 1)[0];
    if (provinsiId) {
      const response = await axios.post(`${tempUrl}/provinsis/${provinsiId}`, {
        _id: user.id,
        token: user.token,
      });
      // setKodeProvinsiTTPenjamin(provinsiId);
      if (response.data) {
        setKodeProvinsiTTPenjamin(
          `${response.data.id} - ${response.data.namaProvinsi}`
        );
      }
    }
  };

  const findTipe = async (id) => {
    id = id.split(" |", 1)[0];
    if (id) {
      const response = await axios.post(`${tempUrl}/tipeByKodeTipe`, {
        kodeTipe: id,
        _id: user.id,
        token: user.token,
      });
      setTipe(id);
      setNoRangka(response.data.noRangka);
      setMerk(response.data.merk);
      setIsi(response.data.isi);
      setNoMesin(response.data.noMesin);
    }
  };

  const tambahSurveyFidusia = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    function base64ToBlob(base64, contentType = "image/png") {
      const byteCharacters = atob(base64.split(",")[1]);
      const byteArrays = [];

      for (let i = 0; i < byteCharacters.length; i += 512) {
        const slice = byteCharacters.slice(i, i + 512);
        const byteNumbers = new Array(slice.length);
        for (let j = 0; j < slice.length; j++) {
          byteNumbers[j] = slice.charCodeAt(j);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      return new Blob(byteArrays, { type: contentType });
    }

    const form = e.currentTarget;
    if (
      form.checkValidity() &&
      kodeKelurahan.length !== 0 &&
      kodeKelurahanTT.length !== 0 &&
      kodeMarketing.length !== 0 &&
      kodeSurveyor.length !== 0
    ) {
      setLoading(true);
      try {
        setLoading(true);

        let ttdSurvey = "";

        if (!canvasRef.current) return;
        canvasRef.current
          .exportImage("png")
          .then(async (data) => {
            // console.log(data);
            const blob = base64ToBlob(data);
            const storage = getStorage();
            const imgRef = ref(storage, `signatures/${Date.now()}.png`);
            await uploadBytes(imgRef, blob);
            const url = await getDownloadURL(imgRef);
            console.log("Uploaded ttdSurvey:", url);
            ttdSurvey = url;
          })
          .catch((e) => {
            console.error(e);
          });

        let denahLokasiSurvey = "";

        if (!canvasRefDenahLokasiSurvey.current) return;
        canvasRefDenahLokasiSurvey.current
          .exportImage("png")
          .then(async (data) => {
            // console.log(data);
            const blob = base64ToBlob(data);
            const storage = getStorage();
            const imgRef = ref(storage, `signatures/${Date.now()}.png`);
            await uploadBytes(imgRef, blob);
            const url = await getDownloadURL(imgRef);
            console.log("Uploaded denahLokasiSurvey:", url);
            denahLokasiSurvey = url;
          })
          .catch((e) => {
            console.error(e);
          });

        while (ttdSurvey.length === 0 || denahLokasiSurvey === 0) {
          await new Promise((res) => setTimeout(res, 1000));
        }
        // console.log("ttdSurvey");
        // console.log(ttdSurvey);
        // console.log("denahLokasiSurvey");
        // console.log(denahLokasiSurvey);

        await axios.post(`${tempUrl}/tambahSurveyFidusia`, {
          registerFidusiaData: {
            registerFidusiaId,
            customerId,
            nikCustomer: nikCustomer.toUpperCase(),
            noKkCustomer: noKkCustomer.toUpperCase(),
            namaCustomer: namaCustomer.toUpperCase(),
            namaPanggilanCustomer: namaPanggilanCustomer.toUpperCase(),
            tempatLahirCustomer: tempatLahirCustomer.toUpperCase(),
            tanggalLahirCustomer,
            jenisKelaminCustomer,
            agamaCustomer,
            noTeleponCustomer: noTeleponCustomer.toUpperCase(),
            alamatCustomer: alamatCustomer.toUpperCase(),
            alamatTTCustomer: alamatTTCustomer.toUpperCase(),
            kelurahanTTId: kodeKelurahanTT,
            statusPerkawinanCustomer,
            pekerjaanCustomer: pekerjaanCustomer.toUpperCase(),
            kewarganegaraanCustomer,

            kelurahanId: kodeKelurahan,
            provinsiId: kodeProvinsi.split(" ", 1)[0],
            kabupatenId: kodeKabupaten.split(" ", 1)[0],
            kecamatanId: kodeKecamatan.split(" ", 1)[0],

            ketProvinsi: ketProvinsi.toUpperCase(),
            ketKabupaten: ketKabupaten.toUpperCase(),
            ketKecamatan: ketKecamatan.toUpperCase(),
            ketKelurahan: ketKelurahan.toUpperCase(),
            kodePos: kodePos,

            kelurahanTTId: kodeKelurahanTT.split(" ", 1)[0],
            provinsiTTId: kodeProvinsiTT.split(" ", 1)[0],
            kabupatenTTId: kodeKabupatenTT.split(" ", 1)[0],
            kecamatanTTId: kodeKecamatanTT.split(" ", 1)[0],

            ketProvinsiTT: ketProvinsiTT.toUpperCase(),
            ketKabupatenTT: ketKabupatenTT.toUpperCase(),
            ketKecamatanTT: ketKecamatanTT.toUpperCase(),
            ketKelurahanTT: ketKelurahanTT.toUpperCase(),
            kodePosTT: kodePosTT,

            namaPerusahaanCustomer: namaPerusahaanCustomer.toUpperCase(),
            bidangUsahaCustomer: bidangUsahaCustomer.toUpperCase(),
            jabatanCustomer: jabatanCustomer.toUpperCase(),
            alamatPerusahaanCustomer: alamatPerusahaanCustomer.toUpperCase(),
            noTeleponPerusahaanCustomer:
              noTeleponPerusahaanCustomer.toUpperCase(),
            lamaKerjaCustomer: lamaKerjaCustomer.toUpperCase(),
            gajiPekerjaanCustomer,
            pendapatanLainCustomer,

            // Data Penjamin
            nikPenjamin: nikPenjamin.toUpperCase(),
            noKkPenjamin: noKkPenjamin.toUpperCase(),
            namaPenjamin: namaPenjamin.toUpperCase(),
            tempatLahirPenjamin: tempatLahirPenjamin.toUpperCase(),
            tanggalLahirPenjamin,
            jenisKelaminPenjamin,
            agamaPenjamin,
            noTeleponPenjamin: noTeleponPenjamin.toUpperCase(),
            alamatPenjamin: alamatPenjamin.toUpperCase(),
            statusPerkawinanPenjamin,
            namaPerusahaanPenjamin,
            alamatPerusahaanPenjamin: alamatPerusahaanPenjamin.toUpperCase(),
            pekerjaanPenjamin: pekerjaanPenjamin.toUpperCase(),
            lamaKerjaPenjamin: lamaKerjaPenjamin.toUpperCase(),
            kewarganegaraanPenjamin,
            hubunganPenjamin: hubunganPenjamin.toUpperCase(),

            kelurahanIdPenjamin: kodeKelurahanPenjamin.split(" ", 1)[0],
            provinsiIdPenjamin: kodeProvinsiPenjamin.split(" ", 1)[0],
            kabupatenIdPenjamin: kodeKabupatenPenjamin.split(" ", 1)[0],
            kecamatanIdPenjamin: kodeKecamatanPenjamin.split(" ", 1)[0],

            ketProvinsiPenjamin: ketProvinsiPenjamin.toUpperCase(),
            ketKabupatenPenjamin: ketKabupatenPenjamin.toUpperCase(),
            ketKecamatanPenjamin: ketKecamatanPenjamin.toUpperCase(),
            ketKelurahanPenjamin: ketKelurahanPenjamin.toUpperCase(),
            kodePosPenjamin: kodePosPenjamin,

            alamatTTPenjamin,
            kelurahanTTIdPenjamin: kodeKelurahanTTPenjamin.split(" ", 1)[0],
            provinsiTTIdPenjamin: kodeProvinsiTTPenjamin.split(" ", 1)[0],
            kabupatenTTIdPenjamin: kodeKabupatenTTPenjamin.split(" ", 1)[0],
            kecamatanTTIdPenjamin: kodeKecamatanTTPenjamin.split(" ", 1)[0],

            ketProvinsiTTPenjamin: ketProvinsiTTPenjamin.toUpperCase(),
            ketKabupatenTTPenjamin: ketKabupatenTTPenjamin.toUpperCase(),
            ketKecamatanTTPenjamin: ketKecamatanTTPenjamin.toUpperCase(),
            ketKelurahanTTPenjamin: ketKelurahanTTPenjamin.toUpperCase(),
            kodePosTTPenjamin: kodePosTTPenjamin,

            uangMuka,
            pinjamanAju,
            angPerBulan,
            tenor,

            merk: merk.toUpperCase(),
            tipe,
            tahun: tahun.toUpperCase(),
            warna,
            nopol: nopol.toUpperCase(),
            keterangan: keterangan.toUpperCase(),

            isSurvey: true,

            userIdUpdate: user.id,
          },
          surveyFidusiaData: {
            registerFidusiaId,

            linkMapsSurvey,

            // DATA REFERENSI
            namaRefRegister: namaRefRegister.toUpperCase(),
            alamatRefRegister: alamatRefRegister.toUpperCase(),
            teleponRefRegister: teleponRefRegister.toUpperCase(),
            hubunganRefRegister: hubunganRefRegister.toUpperCase(),
            // statusPerkawinanRefRegister,
            namaRef2Register: namaRef2Register.toUpperCase(),
            alamatRef2Register: alamatRef2Register.toUpperCase(),
            teleponRef2Register: teleponRef2Register.toUpperCase(),
            hubunganRef2Register: hubunganRef2Register.toUpperCase(),
            // statusPerkawinanRef2Register,
            namaRef3Register: namaRef3Register.toUpperCase(),
            alamatRef3Register: alamatRef3Register.toUpperCase(),
            teleponRef3Register: teleponRef3Register.toUpperCase(),
            hubunganRef3Register: hubunganRef3Register.toUpperCase(),
            // statusPerkawinanRef3Register,

            // DATA PINJAMAN
            hargaOtr,
            uangMuka,
            pinjamanAju,
            angPerBulan,
            tenor,
            tglJtTempo,
            tujuanPenggunaanDana,
            pendinganPengurusan: pendinganPengurusan.toUpperCase(),
            kodeMarketing: kodeMarketing.split(" ", 1)[0],
            kodeSurveyor,

            // DATA KENDARAAN
            merk: merk.toUpperCase(),
            tipe,
            tahun: tahun.toUpperCase(),
            warna,
            isi: isi.toUpperCase(),
            nopol: nopol.toUpperCase(),
            noRangka: noRangka.toUpperCase(),
            noMesin: noMesin.toUpperCase(),
            tglStnk,
            noBpkb: noBpkb.toUpperCase(),
            bpkbAN: bpkbAN.toUpperCase(),
            bpkbAlamat: bpkbAlamat.toUpperCase(),

            keterangan: keterangan.toUpperCase(),

            namaTtdSurvey: namaTtdSurvey.toUpperCase(),

            ttdSurvey,
            denahLokasiSurvey,

            statusSurvey: "BELUM",
            alasanPendingSurvey: "",
            alasanRejectSurvey: "",

            statusSurveyManager: "BELUM",
            alasanRejectSurveyManager: "",

            kodeCabang: user.cabang.id,
            userIdInput: user.id,
          },

          kodeCabang: user.cabang.id,
          userIdInput: user.id,
          _id: user.id,
          token: user.token,
        });
        setLoading(false);
        navigate("/surveyFidusia");
      } catch (error) {
        console.log(error);
        alert(error.response.data.message);
      }
      setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Fidusia</h3>
      <h5 style={{ fontWeight: 400 }}>Tambah Survey Fidusia</h5>
      <hr />
      <Form noValidate validated={validated} onSubmit={tambahSurveyFidusia}>
        {/* Survey */}
        <Card>
          <Card.Header>Survey</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Surveyor <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={surveyorOptions}
                          renderInput={(params) => (
                            <TextField
                              error={error && kodeSurveyor.length === 0 && true}
                              size="small"
                              {...params}
                            />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              setKodeSurveyor(value.label.split(" ", 1)[0]);
                            } else {
                              setKodeSurveyor("");
                            }
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Customer */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Data Pribadi Nasabah</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        NIK / CIF <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="4">
                        <Form.Control value={nikCustomer} disabled readOnly />
                      </Col>
                      <Col sm="3">
                        <Form.Control
                          required
                          value={cif}
                          readOnly
                          placeholder="Pilih..."
                          onClick={() => handleClickOpenRegister()}
                          isInvalid={cif.length === 0 && true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        NIK <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          required
                          value={nikCustomer}
                          onChange={(e) => setNikCustomer(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. KK :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          value={noKkCustomer}
                          onChange={(e) => setNoKkCustomer(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          as="textarea"
                          rows={3}
                          required
                          value={namaCustomer}
                          onChange={(e) => setNamaCustomer(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama Panggilan <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={namaPanggilanCustomer}
                          onChange={(e) =>
                            setNamaPanggilanCustomer(e.target.value)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tempat Lahir <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          required
                          value={tempatLahirCustomer}
                          onChange={(e) =>
                            setTempatLahirCustomer(e.target.value)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tgl. Lahir <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <DatePicker
                          dateFormat="dd/MM/yyyy"
                          customInput={<Form.Control />}
                          selected={tanggalLahirCustomer}
                          onChange={(date) => setTanggalLahirCustomer(date)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Jenis Kelamin <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          required
                          value={jenisKelaminCustomer}
                          onChange={(e) => {
                            setJenisKelaminCustomer(e.target.value);
                          }}
                        >
                          {jenisKelaminOption.map((jenisKelamin) => (
                            <option value={jenisKelamin}>{jenisKelamin}</option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Agama <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          required
                          value={agamaCustomer}
                          onChange={(e) => {
                            setAgamaCustomer(e.target.value);
                          }}
                        >
                          {agamaOption.map((agama) => (
                            <option value={agama}>{agama}</option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Telp / HP <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          required
                          value={noTeleponCustomer}
                          onChange={(e) => setNoTeleponCustomer(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Status Perkawinan <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          required
                          value={statusPerkawinanCustomer}
                          onChange={(e) => {
                            setStatusPerkawinanCustomer(e.target.value);
                          }}
                        >
                          {statusPerkawinanOption.map((statusPerkawinan) => (
                            <option value={statusPerkawinan}>
                              {statusPerkawinan}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                {/* <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Pekerjaan <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control style={{ textTransform: 'uppercase' }}
                          required
                          value={pekerjaanCustomer}
                          onChange={(e) =>
                            setPekerjaanCustomer(e.target.value)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row> */}
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kewarganegaraan <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          required
                          value={kewarganegaraanCustomer}
                          onChange={(e) => {
                            setKewarganegaraanCustomer(e.target.value);
                          }}
                        >
                          {kewarganegaraanOption.map((kewarganegaraan) => (
                            <option value={kewarganegaraan}>
                              {kewarganegaraan}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Alamat (Identitas) */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Alamat (Identitas)</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Alamat <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          as="textarea"
                          rows={3}
                          required
                          value={alamatCustomer}
                          onChange={(e) => setAlamatCustomer(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kel. / Desa <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={kelurahanOptions}
                          renderInput={(params) => (
                            <TextField
                              error={
                                error && kodeKelurahan.length === 0 && true
                              }
                              size="small"
                              {...params}
                            />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              findKelurahan(value.label.split(" ", 1)[0]);
                            } else {
                              findKelurahan("");
                            }
                          }}
                          value={kodeKelurahan}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}></Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          required
                          disabled={kodeKelurahan !== "99999999"}
                          value={ketKelurahan}
                          onChange={(e) => setKetKelurahan(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kecamatan <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={kecamatanOptions}
                          renderInput={(params) => (
                            <TextField
                              error={
                                error && kodeKecamatan.length === 0 && true
                              }
                              size="small"
                              {...params}
                            />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              findKecamatan(value.label);
                            } else {
                              findKecamatan("");
                            }
                          }}
                          value={kodeKecamatan}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}></Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          required
                          disabled={kodeKecamatan.split(" ", 1)[0] !== "999999"}
                          value={ketKecamatan}
                          onChange={(e) => setKetKecamatan(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kabupaten / Kota <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={kabupatenOptions}
                          renderInput={(params) => (
                            <TextField
                              error={
                                error && kodeKabupaten.length === 0 && true
                              }
                              size="small"
                              {...params}
                            />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              findKabupaten(value.label);
                            } else {
                              findKabupaten("");
                            }
                          }}
                          value={kodeKabupaten}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}></Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          required
                          disabled={kodeKabupaten.split(" ", 1)[0] !== "9999"}
                          value={ketKabupaten}
                          onChange={(e) => setKetKabupaten(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Provinsi <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={provinsiOptions}
                          renderInput={(params) => (
                            <TextField
                              error={error && kodeProvinsi.length === 0 && true}
                              size="small"
                              {...params}
                            />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              findProvinsi(value.label);
                            } else {
                              findProvinsi("");
                            }
                          }}
                          value={kodeProvinsi}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}></Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          required
                          disabled={kodeProvinsi.split(" ", 1)[0] !== "99"}
                          value={ketProvinsi}
                          onChange={(e) => setKetProvinsi(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kode POS <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          required
                          type="number"
                          value={kodePos}
                          disabled={
                            kodeKelurahan.split(" ", 1)[0] !== "99999999"
                          }
                          onChange={(e) => setKodePos(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Tempat Tinggal */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Tempat Tinggal</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Card style={{ marginTop: "10px" }}>
                  <Card.Header>
                    <Box
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <Box></Box>
                      <Box>
                        <Form.Check
                          type="checkbox"
                          label="Sama dengan alamat identitas"
                          checked={alamatSama}
                          onChange={() => {
                            setAlamatSama(!alamatSama);
                            if (!alamatSama === true) {
                              setAlamatTTCustomer(alamatCustomer);
                              setKodeKelurahanTT(kodeKelurahan);
                              setKetKelurahanTT(ketKelurahan);
                              setKodeKecamatanTT(kodeKecamatan);
                              setKetKecamatanTT(ketKecamatan);
                              setKodeKabupatenTT(kodeKabupaten);
                              setKetKabupatenTT(ketKabupaten);
                              setKodeProvinsiTT(kodeProvinsi);
                              setKetProvinsiTT(ketProvinsi);
                              setKodePosTT(kodePos);
                            }
                          }}
                        />
                      </Box>
                    </Box>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Alamat <b style={colorRed}>*</b> :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              as="textarea"
                              rows={3}
                              required
                              value={alamatTTCustomer}
                              onChange={(e) =>
                                setAlamatTTCustomer(e.target.value)
                              }
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kel. / Desa <b style={colorRed}>*</b> :
                          </Form.Label>
                          <Col sm="7">
                            <Autocomplete
                              size="small"
                              disablePortal
                              id="combo-box-demo"
                              options={kelurahanOptions}
                              renderInput={(params) => (
                                <TextField
                                  error={
                                    error &&
                                    kodeKelurahanTT.length === 0 &&
                                    true
                                  }
                                  size="small"
                                  {...params}
                                />
                              )}
                              onChange={(e, value) => {
                                if (value) {
                                  findKelurahanTT(value.label.split(" ", 1)[0]);
                                } else {
                                  findKelurahanTT("");
                                }
                              }}
                              value={kodeKelurahanTT}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label
                            column
                            sm="5"
                            style={textRight}
                          ></Form.Label>
                          <Col sm="7">
                            <Form.Control
                              style={{ textTransform: "uppercase" }}
                              required
                              disabled={
                                kodeKelurahanTT.split(" ", 1)[0] !== "99999999"
                              }
                              value={ketKelurahanTT}
                              onChange={(e) =>
                                setKetKelurahanTT(e.target.value)
                              }
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kecamatan <b style={colorRed}>*</b> :
                          </Form.Label>
                          <Col sm="7">
                            <Autocomplete
                              size="small"
                              disablePortal
                              id="combo-box-demo"
                              options={kecamatanOptions}
                              renderInput={(params) => (
                                <TextField
                                  error={
                                    error &&
                                    kodeKecamatanTT.length === 0 &&
                                    true
                                  }
                                  size="small"
                                  {...params}
                                />
                              )}
                              onChange={(e, value) => {
                                if (value) {
                                  findKecamatanTT(value.label);
                                } else {
                                  findKecamatanTT("");
                                }
                              }}
                              value={kodeKecamatanTT}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label
                            column
                            sm="5"
                            style={textRight}
                          ></Form.Label>
                          <Col sm="7">
                            <Form.Control
                              style={{ textTransform: "uppercase" }}
                              required
                              disabled={
                                kodeKecamatanTT.split(" ", 1)[0] !== "999999"
                              }
                              value={ketKecamatanTT}
                              onChange={(e) =>
                                setKetKecamatanTT(e.target.value)
                              }
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kabupaten / Kota <b style={colorRed}>*</b> :
                          </Form.Label>
                          <Col sm="7">
                            <Autocomplete
                              size="small"
                              disablePortal
                              id="combo-box-demo"
                              options={kabupatenOptions}
                              renderInput={(params) => (
                                <TextField
                                  error={
                                    error &&
                                    kodeKabupatenTT.length === 0 &&
                                    true
                                  }
                                  size="small"
                                  {...params}
                                />
                              )}
                              onChange={(e, value) => {
                                if (value) {
                                  findKabupatenTT(value.label);
                                } else {
                                  findKabupatenTT("");
                                }
                              }}
                              value={kodeKabupatenTT}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label
                            column
                            sm="5"
                            style={textRight}
                          ></Form.Label>
                          <Col sm="7">
                            <Form.Control
                              style={{ textTransform: "uppercase" }}
                              required
                              disabled={
                                kodeKabupatenTT.split(" ", 1)[0] !== "9999"
                              }
                              value={ketKabupatenTT}
                              onChange={(e) =>
                                setKetKabupatenTT(e.target.value)
                              }
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Provinsi <b style={colorRed}>*</b> :
                          </Form.Label>
                          <Col sm="7">
                            <Autocomplete
                              size="small"
                              disablePortal
                              id="combo-box-demo"
                              options={provinsiOptions}
                              renderInput={(params) => (
                                <TextField
                                  error={
                                    error && kodeProvinsiTT.length === 0 && true
                                  }
                                  size="small"
                                  {...params}
                                />
                              )}
                              onChange={(e, value) => {
                                if (value) {
                                  findProvinsiTT(value.label);
                                } else {
                                  findProvinsiTT("");
                                }
                              }}
                              value={kodeProvinsiTT}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label
                            column
                            sm="5"
                            style={textRight}
                          ></Form.Label>
                          <Col sm="7">
                            <Form.Control
                              style={{ textTransform: "uppercase" }}
                              required
                              disabled={
                                kodeProvinsiTT.split(" ", 1)[0] !== "99"
                              }
                              value={ketProvinsiTT}
                              onChange={(e) => setKetProvinsiTT(e.target.value)}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kode POS <b style={colorRed}>*</b> :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              style={{ textTransform: "uppercase" }}
                              required
                              type="number"
                              value={kodePosTT}
                              disabled={
                                kodeKelurahanTT.split(" ", 1)[0] !== "99999999"
                              }
                              onChange={(e) => setKodePosTT(e.target.value)}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Lokasi Tempat Tinggal */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Lokasi Tempat Tinggal</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Link Map :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={linkMapsSurvey}
                          onChange={(e) => setLinkMapsSurvey(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Pekerjaan */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Data Pekerjaan</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama Perusahaan / Usaha <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={namaPerusahaanCustomer}
                          onChange={(e) =>
                            setNamaPerusahaanCustomer(e.target.value)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Bidang Usaha <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          required
                          value={bidangUsahaCustomer}
                          onChange={(e) =>
                            setBidangUsahaCustomer(e.target.value)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Jabatan / Posisi <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          required
                          value={jabatanCustomer}
                          onChange={(e) => setJabatanCustomer(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Alamat Perusahaan / Usaha <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={alamatPerusahaanCustomer}
                          onChange={(e) =>
                            setAlamatPerusahaanCustomer(e.target.value)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No .Telp Perusahaan :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          value={noTeleponPerusahaanCustomer}
                          onChange={(e) =>
                            setNoTeleponPerusahaanCustomer(e.target.value)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Lama Kerja / Status <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          required
                          value={lamaKerjaCustomer}
                          onChange={(e) => setLamaKerjaCustomer(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Besaran Gaji / Bulan <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={gajiPekerjaanCustomer}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setGajiPekerjaanCustomer(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, "")
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Pendapatan Lain :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          value={pendapatanLainCustomer}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setPendapatanLainCustomer(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, "")
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Data Penjamin */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Data Penjamin</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        NIK :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          value={nikPenjamin}
                          onChange={(e) => setNikPenjamin(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. KK :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          value={noKkPenjamin}
                          onChange={(e) => setNoKkPenjamin(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          as="textarea"
                          rows={3}
                          value={namaPenjamin}
                          onChange={(e) => setNamaPenjamin(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tempat Lahir :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          value={tempatLahirPenjamin}
                          onChange={(e) =>
                            setTempatLahirPenjamin(e.target.value)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tgl. Lahir :
                      </Form.Label>
                      <Col sm="7">
                        <DatePicker
                          dateFormat="dd/MM/yyyy"
                          customInput={<Form.Control />}
                          selected={tanggalLahirPenjamin}
                          onChange={(date) => setTanggalLahirPenjamin(date)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Jenis Kelamin :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          value={jenisKelaminPenjamin}
                          onChange={(e) => {
                            setJenisKelaminPenjamin(e.target.value);
                          }}
                        >
                          {jenisKelaminOption.map((jenisKelamin) => (
                            <option value={jenisKelamin}>{jenisKelamin}</option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Agama :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          value={agamaPenjamin}
                          onChange={(e) => {
                            setAgamaPenjamin(e.target.value);
                          }}
                        >
                          {agamaOption.map((agama) => (
                            <option value={agama}>{agama}</option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Telp / HP :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          type="number"
                          value={noTeleponPenjamin}
                          onChange={(e) => setNoTeleponPenjamin(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Status Perkawinan :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          value={statusPerkawinanPenjamin}
                          onChange={(e) => {
                            setStatusPerkawinanPenjamin(e.target.value);
                          }}
                        >
                          {statusPerkawinanOption.map((statusPerkawinan) => (
                            <option value={statusPerkawinan}>
                              {statusPerkawinan}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama Perusahaan / Usaha :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          value={namaPerusahaanPenjamin}
                          onChange={(e) =>
                            setNamaPerusahaanPenjamin(e.target.value)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Alamat Perusahaan :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          value={alamatPerusahaanPenjamin}
                          onChange={(e) =>
                            setAlamatPerusahaanPenjamin(e.target.value)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Pekerjaan :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          value={pekerjaanPenjamin}
                          onChange={(e) => setPekerjaanPenjamin(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Lama Kerja / Status :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          value={lamaKerjaPenjamin}
                          onChange={(e) => setLamaKerjaPenjamin(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kewarganegaraan :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          value={kewarganegaraanPenjamin}
                          onChange={(e) => {
                            setKewarganegaraanPenjamin(e.target.value);
                          }}
                        >
                          {kewarganegaraanOption.map((kewarganegaraan) => (
                            <option value={kewarganegaraan}>
                              {kewarganegaraan}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Hubungan dengan nasabah :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          value={hubunganPenjamin}
                          onChange={(e) => setHubunganPenjamin(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Alamat (Identitas) Penjamin */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Alamat (Identitas) Penjamin</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Alamat :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          as="textarea"
                          rows={3}
                          value={alamatPenjamin}
                          onChange={(e) => setAlamatPenjamin(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kel. / Desa :
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={kelurahanOptions}
                          renderInput={(params) => (
                            <TextField size="small" {...params} />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              findKelurahanPenjamin(
                                value.label.split(" ", 1)[0]
                              );
                            } else {
                              findKelurahanPenjamin("");
                            }
                          }}
                          value={kodeKelurahanPenjamin}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}></Form.Label>
                      <Col sm="7">
                        <Form.Control
                          disabled={kodeKelurahanPenjamin !== "99999999"}
                          value={ketKelurahanPenjamin}
                          onChange={(e) =>
                            setKetKelurahanPenjamin(e.target.value)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kecamatan :
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={kecamatanOptions}
                          renderInput={(params) => (
                            <TextField size="small" {...params} />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              findKecamatanPenjamin(value.label);
                            } else {
                              findKecamatanPenjamin("");
                            }
                          }}
                          value={kodeKecamatanPenjamin}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}></Form.Label>
                      <Col sm="7">
                        <Form.Control
                          disabled={
                            kodeKecamatanPenjamin.split(" ", 1)[0] !== "999999"
                          }
                          value={ketKecamatanPenjamin}
                          onChange={(e) =>
                            setKetKecamatanPenjamin(e.target.value)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kabupaten / Kota :
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={kabupatenOptions}
                          renderInput={(params) => (
                            <TextField size="small" {...params} />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              findKabupatenPenjamin(value.label);
                            } else {
                              findKabupatenPenjamin("");
                            }
                          }}
                          value={kodeKabupatenPenjamin}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}></Form.Label>
                      <Col sm="7">
                        <Form.Control
                          disabled={
                            kodeKabupatenPenjamin.split(" ", 1)[0] !== "9999"
                          }
                          value={ketKabupatenPenjamin}
                          onChange={(e) =>
                            setKetKabupatenPenjamin(e.target.value)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Provinsi :
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={provinsiOptions}
                          renderInput={(params) => (
                            <TextField size="small" {...params} />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              findProvinsiPenjamin(value.label);
                            } else {
                              findProvinsiPenjamin("");
                            }
                          }}
                          value={kodeProvinsiPenjamin}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}></Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          disabled={
                            kodeProvinsiPenjamin.split(" ", 1)[0] !== "99"
                          }
                          value={ketProvinsiPenjamin}
                          onChange={(e) =>
                            setKetProvinsiPenjamin(e.target.value)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kode POS :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          type="number"
                          value={kodePosPenjamin}
                          disabled={
                            kodeKelurahanPenjamin.split(" ", 1)[0] !==
                            "99999999"
                          }
                          onChange={(e) => setKodePosPenjamin(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Tempat Tinggal */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Tempat Tinggal</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Card style={{ marginTop: "10px" }}>
                  <Card.Header>
                    <Box
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <Box></Box>
                      <Box>
                        <Form.Check
                          type="checkbox"
                          label="Sama dengan alamat identitas"
                          checked={alamatSamaPenjamin}
                          onChange={() => {
                            setAlamatSamaPenjamin(!alamatSamaPenjamin);
                            if (!alamatSamaPenjamin === true) {
                              setAlamatTTPenjamin(alamatPenjamin);
                              setKodeKelurahanTTPenjamin(kodeKelurahanPenjamin);
                              setKetKelurahanTTPenjamin(ketKelurahanPenjamin);
                              setKodeKecamatanTTPenjamin(kodeKecamatanPenjamin);
                              setKetKecamatanTTPenjamin(ketKecamatanPenjamin);
                              setKodeKabupatenTTPenjamin(kodeKabupatenPenjamin);
                              setKetKabupatenTTPenjamin(ketKabupatenPenjamin);
                              setKodeProvinsiTTPenjamin(kodeProvinsiPenjamin);
                              setKetProvinsiTTPenjamin(ketProvinsiPenjamin);
                              setKodePosTTPenjamin(kodePosPenjamin);
                            }
                          }}
                        />
                      </Box>
                    </Box>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Alamat :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              as="textarea"
                              rows={3}
                              value={alamatTTPenjamin}
                              onChange={(e) =>
                                setAlamatTTPenjamin(e.target.value)
                              }
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kel. / Desa :
                          </Form.Label>
                          <Col sm="7">
                            <Autocomplete
                              size="small"
                              disablePortal
                              id="combo-box-demo"
                              options={kelurahanOptions}
                              renderInput={(params) => (
                                <TextField size="small" {...params} />
                              )}
                              onChange={(e, value) => {
                                if (value) {
                                  findKelurahanTTPenjamin(
                                    value.label.split(" ", 1)[0]
                                  );
                                } else {
                                  findKelurahanTTPenjamin("");
                                }
                              }}
                              value={kodeKelurahanTTPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label
                            column
                            sm="5"
                            style={textRight}
                          ></Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled={
                                kodeKelurahanTTPenjamin.split(" ", 1)[0] !==
                                "99999999"
                              }
                              value={ketKelurahanTTPenjamin}
                              onChange={(e) =>
                                setKetKelurahanTTPenjamin(e.target.value)
                              }
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kecamatan :
                          </Form.Label>
                          <Col sm="7">
                            <Autocomplete
                              size="small"
                              disablePortal
                              id="combo-box-demo"
                              options={kecamatanOptions}
                              renderInput={(params) => (
                                <TextField size="small" {...params} />
                              )}
                              onChange={(e, value) => {
                                if (value) {
                                  findKecamatanTTPenjamin(value.label);
                                } else {
                                  findKecamatanTTPenjamin("");
                                }
                              }}
                              value={kodeKecamatanTTPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label
                            column
                            sm="5"
                            style={textRight}
                          ></Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled={
                                kodeKecamatanTTPenjamin.split(" ", 1)[0] !==
                                "999999"
                              }
                              value={ketKecamatanTTPenjamin}
                              onChange={(e) =>
                                setKetKecamatanTTPenjamin(e.target.value)
                              }
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kabupaten / Kota :
                          </Form.Label>
                          <Col sm="7">
                            <Autocomplete
                              size="small"
                              disablePortal
                              id="combo-box-demo"
                              options={kabupatenOptions}
                              renderInput={(params) => (
                                <TextField size="small" {...params} />
                              )}
                              onChange={(e, value) => {
                                if (value) {
                                  findKabupatenTTPenjamin(value.label);
                                } else {
                                  findKabupatenTTPenjamin("");
                                }
                              }}
                              value={kodeKabupatenTTPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label
                            column
                            sm="5"
                            style={textRight}
                          ></Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled={
                                kodeKabupatenTTPenjamin.split(" ", 1)[0] !==
                                "9999"
                              }
                              value={ketKabupatenTTPenjamin}
                              onChange={(e) =>
                                setKetKabupatenTTPenjamin(e.target.value)
                              }
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Provinsi :
                          </Form.Label>
                          <Col sm="7">
                            <Autocomplete
                              size="small"
                              disablePortal
                              id="combo-box-demo"
                              options={provinsiOptions}
                              renderInput={(params) => (
                                <TextField size="small" {...params} />
                              )}
                              onChange={(e, value) => {
                                if (value) {
                                  findProvinsiTTPenjamin(value.label);
                                } else {
                                  findProvinsiTTPenjamin("");
                                }
                              }}
                              value={kodeProvinsiTTPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label
                            column
                            sm="5"
                            style={textRight}
                          ></Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled={
                                kodeProvinsiTTPenjamin.split(" ", 1)[0] !== "99"
                              }
                              value={ketProvinsiTTPenjamin}
                              onChange={(e) =>
                                setKetProvinsiTTPenjamin(e.target.value)
                              }
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kode POS :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              type="number"
                              value={kodePosTTPenjamin}
                              disabled={
                                kodeKelurahanTTPenjamin.split(" ", 1)[0] !==
                                "99999999"
                              }
                              onChange={(e) =>
                                setKodePosTTPenjamin(e.target.value)
                              }
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Data Referensi */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Data Referensi</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama Ref. Register :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          value={namaRefRegister}
                          onChange={(e) => setNamaRefRegister(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Telepon Ref. Register :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          value={teleponRefRegister}
                          onChange={(e) =>
                            setTeleponRefRegister(e.target.value)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Alamat Ref. Register :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          value={alamatRefRegister}
                          onChange={(e) => setAlamatRefRegister(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Hubungan dengan Nasabah :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          value={hubunganRefRegister}
                          onChange={(e) =>
                            setHubunganRefRegister(e.target.value)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                {/* <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Status Perkawinan :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          value={statusPerkawinanRefRegister}
                          onChange={(e) => {
                            setStatusPerkawinanRefRegister(e.target.value);
                          }}
                        >
                          {statusPerkawinanOption.map((statusPerkawinan) => (
                            <option value={statusPerkawinan}>
                              {statusPerkawinan}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row> */}

                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama Ref. Register 2 :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          value={namaRef2Register}
                          onChange={(e) => setNamaRef2Register(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Telepon Ref. Register 2 :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          value={teleponRef2Register}
                          onChange={(e) =>
                            setTeleponRef2Register(e.target.value)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Alamat Ref. Register 2 :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          value={alamatRef2Register}
                          onChange={(e) =>
                            setAlamatRef2Register(e.target.value)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Hubungan dengan Nasabah 2 :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          value={hubunganRef2Register}
                          onChange={(e) =>
                            setHubunganRef2Register(e.target.value)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                {/* <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Status Perkawinan :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          value={statusPerkawinanRef2Register}
                          onChange={(e) => {
                            setStatusPerkawinanRef2Register(e.target.value);
                          }}
                        >
                          {statusPerkawinanOption.map((statusPerkawinan) => (
                            <option value={statusPerkawinan}>
                              {statusPerkawinan}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row> */}

                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama Ref. Register 3 :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          value={namaRef3Register}
                          onChange={(e) => setNamaRef3Register(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Telepon Ref. Register 3 :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          value={teleponRef3Register}
                          onChange={(e) =>
                            setTeleponRef3Register(e.target.value)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Alamat Ref. Register 3 :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          value={alamatRef3Register}
                          onChange={(e) =>
                            setAlamatRef3Register(e.target.value)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Hubungan dengan Nasabah 3 :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          value={hubunganRef3Register}
                          onChange={(e) =>
                            setHubunganRef3Register(e.target.value)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                {/* <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Status Perkawinan :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          value={statusPerkawinanRef3Register}
                          onChange={(e) => {
                            setStatusPerkawinanRef3Register(e.target.value);
                          }}
                        >
                          {statusPerkawinanOption.map((statusPerkawinan) => (
                            <option value={statusPerkawinan}>
                              {statusPerkawinan}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row> */}
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Data Pembiayaan / Struktur Pinjaman */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Data Pembiayaan / Struktur Pinjaman</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Harga OTR :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          value={hargaOtr}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setHargaOtr(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, "")
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Uang Muka <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={uangMuka}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setUangMuka(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, "")
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Pokok Hutang <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={pinjamanAju}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setPinjamanAju(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, "")
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Angsuran / Bulan <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={angPerBulan}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setAngPerBulan(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, "")
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tenor <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={tenor}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setTenor(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, "")
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tgl. Jt Tempo :
                      </Form.Label>
                      <Col sm="7">
                        <DatePicker
                          dateFormat="dd/MM/yyyy"
                          customInput={<Form.Control />}
                          selected={tglJtTempo}
                          onChange={(date) => setTglJtTempo(date)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tujuan Penggunaan Dana :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          value={tujuanPenggunaanDana}
                          onChange={(e) =>
                            setTujuanPenggunaanDana(e.target.value)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Pendingan / Pengurusan :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          value={pendinganPengurusan}
                          onChange={(e) =>
                            setPendinganPengurusan(e.target.value)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Sumber Order / Marketing <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={marketingOptions}
                          renderInput={(params) => (
                            <TextField
                              error={
                                error && kodeMarketing.length === 0 && true
                              }
                              size="small"
                              {...params}
                            />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              setKodeMarketing(value.label);
                            } else {
                              setKodeMarketing("");
                            }
                          }}
                          value={kodeMarketing}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Data Kendaraan */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Data Kendaraan</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Merk <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          required
                          value={merk}
                          onChange={(e) => setMerk(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tipe <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={tipeOptions}
                          renderInput={(params) => (
                            <TextField
                              error={error && tipe.length === 0 && true}
                              size="small"
                              {...params}
                            />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              findTipe(value.label);
                            } else {
                              findTipe("");
                            }
                          }}
                          value={tipe}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tahun <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          required
                          value={tahun}
                          onChange={(e) => setTahun(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Warna <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          required
                          value={warna}
                          onChange={(e) => {
                            setWarna(e.target.value);
                          }}
                        >
                          {warnas.map((warna, index) => (
                            <option value={warna.namaWarna}>
                              {warna.namaWarna}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        CC :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          value={isi}
                          onChange={(e) => setIsi(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Polisi <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          required
                          value={nopol}
                          onChange={(e) => setNopol(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Rangka :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          value={noRangka}
                          onChange={(e) => setNoRangka(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Mesin :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          value={noMesin}
                          onChange={(e) => setNoMesin(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tgl. STNK :
                      </Form.Label>
                      <Col sm="7">
                        <DatePicker
                          dateFormat="dd/MM/yyyy"
                          customInput={<Form.Control />}
                          selected={tglStnk}
                          onChange={(date) => setTglStnk(date)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Bpkb :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          value={noBpkb}
                          onChange={(e) => setNoBpkb(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        BPKB A/N :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          value={bpkbAN}
                          onChange={(e) => setBpkbAN(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Alamat BPKB :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          value={bpkbAlamat}
                          onChange={(e) => setBpkbAlamat(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Denah Lokasi */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Denah Lokasi</Card.Header>
          <Card.Body>
            <Box sx={keteranganContainer}>
              <div>
                <div className="d-flex flex-wrap gap-2 align-items-center">
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    disabled={!eraseModeDenahLokasiSurvey}
                    onClick={handlePenClickDenahLokasiSurvey}
                  >
                    Pen
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    disabled={eraseModeDenahLokasiSurvey}
                    onClick={handleEraserClickDenahLokasiSurvey}
                  >
                    Hapus
                  </button>
                  <div className="vr" />
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={handleUndoClickDenahLokasiSurvey}
                  >
                    Undo
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={handleRedoClickDenahLokasiSurvey}
                  >
                    Redo
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={handleClearClickDenahLokasiSurvey}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={handleResetClickDenahLokasiSurvey}
                  >
                    Reset
                  </button>
                </div>
              </div>
            </Box>
            <Box style={{ marginTop: "20px", height: "300px" }}>
              <ReactSketchCanvas
                ref={canvasRefDenahLokasiSurvey}
                strokeWidth={5}
                strokeColor="black"
              />
              {/* <button onClick={handleExportImage}>Get Image</button> */}
            </Box>
          </Card.Body>
        </Card>

        {/* Keterangan */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Keterangan</Card.Header>
          <Card.Body>
            <Box sx={keteranganContainer}>
              <Form.Control
                style={{ textTransform: "uppercase" }}
                as="textarea"
                rows={3}
                value={keterangan}
                onChange={(e) => setKeterangan(e.target.value)}
              />
            </Box>
            <Box sx={keteranganContainer}>
              <Form.Control
                as="textarea"
                rows={6}
                disabled
                value={keteranganSurvey}
              />
            </Box>
            <Box sx={keteranganContainer}>
              <Box sx={textFieldWrapper}></Box>
              <Box sx={[textFieldWrapper, secondWrapper]}>
                <div>
                  <div className="d-flex flex-wrap gap-2 align-items-center">
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      disabled={!eraseMode}
                      onClick={handlePenClick}
                    >
                      Pen
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      disabled={eraseMode}
                      onClick={handleEraserClick}
                    >
                      Hapus
                    </button>
                    <div className="vr" />
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      onClick={handleUndoClick}
                    >
                      Undo
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      onClick={handleRedoClick}
                    >
                      Redo
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      onClick={handleClearClick}
                    >
                      Clear
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      onClick={handleResetClick}
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </Box>
            </Box>
            <Box sx={keteranganContainer}>
              <Box sx={textFieldWrapper}></Box>
              <Box sx={[textFieldWrapper, secondWrapper]}>
                <div>
                  <ReactSketchCanvas
                    ref={canvasRef}
                    strokeWidth={5}
                    strokeColor="black"
                  />
                  {/* <button onClick={handleExportImage}>Get Image</button> */}
                </div>
              </Box>
            </Box>
            <Box sx={keteranganContainer}>
              <Box sx={textFieldWrapper}></Box>
              <Box sx={[textFieldWrapper, secondWrapper]}>
                <InputGroup className="mb-3">
                  <InputGroup.Text id="basic-addon1">{"("}</InputGroup.Text>
                  <Form.Control
                    style={{ textTransform: "uppercase" }}
                    value={namaTtdSurvey}
                    onChange={(e) => setNamaTtdSurvey(e.target.value)}
                  />
                  <InputGroup.Text id="basic-addon1">{")"}</InputGroup.Text>
                </InputGroup>
              </Box>
            </Box>
          </Card.Body>
        </Card>

        <Box sx={spacingTop}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => navigate("/surveyFidusia")}
            sx={{ marginRight: 2 }}
          >
            {"< Kembali"}
          </Button>
          <Button variant="contained" startIcon={<SaveIcon />} type="submit">
            Simpan
          </Button>
        </Box>
      </Form>
      <Dialog
        open={openRegister}
        onClose={handleCloseRegister}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Pilih Data Register`}</DialogTitle>
        <DialogActions>
          <Box sx={dialogContainer}>
            <Form onSubmit={searchData}>
              <Box sx={searchBarContainer}>
                <SearchBar value={query} setSearchTerm={setQuery} />
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  disableElevation
                >
                  Cari
                </Button>
              </Box>
            </Form>
            <TableContainer component={Paper} sx={dialogWrapper}>
              <Table aria-label="simple table">
                <TableHead className={classes.root}>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Nama
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Alamat
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      No. Telp / HP
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {registers.map((register, index) => (
                    <TableRow
                      key={register._id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        "&:hover": { bgcolor: Colors.grey300 },
                        cursor: "pointer",
                      }}
                      onClick={async () => {
                        setRegisterFidusiaId(register.id);
                        setCustomerId(register.customer.id);
                        setCif(register.customer.cifCustomer);
                        setNikCustomer(register.customer.nikCustomer);
                        setNoKkCustomer(register.customer.noKkCustomer);
                        setNamaCustomer(register.customer.namaCustomer);
                        setNamaPanggilanCustomer(
                          register.customer.namaPanggilanCustomer
                        );
                        setTempatLahirCustomer(
                          register.customer.tempatLahirCustomer
                        );
                        setTanggalLahirCustomer(
                          new Date(register.customer.tanggalLahirCustomer)
                        );
                        setJenisKelaminCustomer(
                          register.customer.jenisKelaminCustomer
                        );
                        setAgamaCustomer(register.customer.agamaCustomer);
                        setNoTeleponCustomer(
                          register.customer.noTeleponCustomer
                        );
                        setAlamatCustomer(register.customer.alamatCustomer);
                        setAlamatTTCustomer(register.customer.alamatTTCustomer);
                        setKodeProvinsi(
                          `${register.customer.provinsis.id} - ${register.customer.provinsis.namaProvinsi}`
                        );
                        setKodeProvinsiTT(
                          `${register.customer.provinsisTT.id} - ${register.customer.provinsisTT.namaProvinsi}`
                        );
                        setKodeKabupaten(
                          `${register.customer.kabupaten.id} - ${register.customer.kabupaten.namaKabupaten}`
                        );
                        setKodeKabupatenTT(
                          `${register.customer.kabupatenTT.id} - ${register.customer.kabupatenTT.namaKabupaten}`
                        );
                        setKodeKecamatan(
                          `${register.customer.kecamatan.id} - ${register.customer.kecamatan.namaKecamatan}`
                        );
                        setKodeKecamatanTT(
                          `${register.customer.kecamatanTT.id} - ${register.customer.kecamatanTT.namaKecamatan}`
                        );
                        setKodeKelurahan(
                          `${register.customer.kelurahan.id} - ${register.customer.kelurahan.namaKelurahan}`
                        );
                        setKodeKelurahanTT(
                          `${register.customer.kelurahanTT.id} - ${register.customer.kelurahanTT.namaKelurahan}`
                        );
                        setKodePos(register.customer.kelurahan.kodePos);
                        setKodePosTT(register.customer.kelurahanTT.kodePos);
                        setStatusPerkawinanCustomer(
                          register.customer.statusPerkawinanCustomer
                        );
                        setPekerjaanCustomer(
                          register.customer.pekerjaanCustomer
                        );
                        setKewarganegaraanCustomer(
                          register.customer.kewarganegaraanCustomer
                        );

                        setNamaPerusahaanCustomer(
                          register.customer.namaPerusahaanCustomer
                        );
                        setBidangUsahaCustomer(
                          register.customer.bidangUsahaCustomer
                        );
                        setJabatanCustomer(register.customer.jabatanCustomer);
                        setAlamatPerusahaanCustomer(
                          register.customer.alamatPerusahaanCustomer
                        );
                        setNoTeleponPerusahaanCustomer(
                          register.customer.noTeleponPerusahaanCustomer
                        );
                        setLamaKerjaCustomer(
                          register.customer.lamaKerjaCustomer
                        );
                        setGajiPekerjaanCustomer(
                          register.customer.gajiPekerjaanCustomer
                        );
                        setPendapatanLainCustomer(
                          register.customer.pendapatanLainCustomer
                        );

                        setNikPenjamin(register.nikPenjamin);
                        setNoKkPenjamin(register.noKkPenjamin);
                        setNamaPenjamin(register.namaPenjamin);
                        setTempatLahirPenjamin(register.tempatLahirPenjamin);
                        setTanggalLahirPenjamin(
                          register.tanggalLahirPenjamin &&
                            new Date(register.tanggalLahirPenjamin)
                        );
                        setJenisKelaminPenjamin(register.jenisKelaminPenjamin);
                        setAgamaPenjamin(register.agamaPenjamin);
                        setNoTeleponPenjamin(register.noTeleponPenjamin);
                        setAlamatPenjamin(register.alamatPenjamin);
                        if (register.provinsisPenjamin) {
                          setKodeProvinsiPenjamin(
                            `${register.provinsisPenjamin.id} - ${register.provinsisPenjamin.namaProvinsi}`
                          );
                        }
                        if (register.kabupatenPenjamin) {
                          setKodeKabupatenPenjamin(
                            `${register.kabupatenPenjamin.id} - ${register.kabupatenPenjamin.namaKabupaten}`
                          );
                        }
                        if (register.kecamatanPenjamin) {
                          setKodeKecamatanPenjamin(
                            `${register.kecamatanPenjamin.id} - ${register.kecamatanPenjamin.namaKecamatan}`
                          );
                        }
                        if (register.kelurahanPenjamin) {
                          setKodeKelurahanPenjamin(
                            `${register.kelurahanPenjamin.id} - ${register.kelurahanPenjamin.namaKelurahan}`
                          );
                        }
                        if (register.kelurahanPenjamin) {
                          setKodePosPenjamin(
                            register.kelurahanPenjamin.kodePos
                          );
                        }
                        setStatusPerkawinanPenjamin(
                          register.statusPerkawinanPenjamin
                        );
                        setPekerjaanPenjamin(register.pekerjaanPenjamin);
                        setKewarganegaraanPenjamin(
                          register.kewarganegaraanPenjamin
                        );
                        setHubunganPenjamin(register.hubunganPenjamin);

                        setAlamatSamaPenjamin(register.alamatSamaPenjamin);
                        setAlamatTTPenjamin(register.alamatTTPenjamin);
                        if (register.provinsisTTPenjamin) {
                          setKodeProvinsiTTPenjamin(
                            `${register.provinsisTTPenjamin.id} - ${register.provinsisTTPenjamin.namaProvinsi}`
                          );
                        }
                        if (register.kabupatenTTPenjamin) {
                          setKodeKabupatenTTPenjamin(
                            `${register.kabupatenTTPenjamin.id} - ${register.kabupatenTTPenjamin.namaKabupaten}`
                          );
                        }
                        if (register.kecamatanTTPenjamin) {
                          setKodeKecamatanTTPenjamin(
                            `${register.kecamatanTTPenjamin.id} - ${register.kecamatanTTPenjamin.namaKecamatan}`
                          );
                        }
                        if (register.kelurahanTTPenjamin) {
                          setKodeKelurahanTTPenjamin(
                            `${register.kelurahanTTPenjamin.id} - ${register.kelurahanTTPenjamin.namaKelurahan}`
                          );
                        }
                        if (register.kelurahanTTPenjamin) {
                          setKodePosTTPenjamin(
                            register.kelurahanTTPenjamin.kodePos
                          );
                        }

                        setUangMuka(register.uangMuka);
                        setPinjamanAju(register.pinjamanAju);
                        setAngPerBulan(register.angPerBulan);
                        setTenor(register.tenor);
                        if (register.marketing) {
                          setKodeMarketing(
                            `${register.marketing.kodeMarketing} - ${register.marketing.namaMarketing}`
                          );
                        }

                        setMerk(register.merk);
                        setTipe(register.tipe);
                        findTipe(register.tipe);
                        setTahun(register.tahun);
                        setWarna(register.warna);
                        setNopol(register.nopol);

                        handleCloseRegister();
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {register.customer.namaCustomer}
                      </TableCell>
                      <TableCell>{register.customer.alamatCustomer}</TableCell>
                      <TableCell>
                        {register.customer.noTeleponCustomer}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={tableContainer}>
              <Pagination
                count={pages}
                page={page + 1}
                onChange={handleChange}
                color="primary"
                size={screenSize <= 600 ? "small" : "large"}
              />
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
    </Container>
  );
};

export default TambahSurveyFidusia;

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const keteranganContainer = {
  marginTop: "20px",
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const textFieldContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const textFieldWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const colorRed = {
  color: "red",
};

const dialogContainer = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const dialogWrapper = {
  width: "100%",
  marginTop: 2,
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};
